import React, { ReactElement } from 'react';
import type { Route } from 'next';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import Breadcrumbs from 'components/Breadcrumbs';
import 'swiper/css';
import styles from 'pages/resources/freight-templates/dangerous-goods-declaration/DagerousGoodsDeclaration.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionHeader/'));
const SectionAbout = dynamic(() => import('sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionAbout/'));
const SectionPurpose = dynamic(() => import('sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionPurpose/'));
const SectionDocuments = dynamic(() => import('sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionDocuments/'));
const SectionFaq = dynamic(() => import('sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionFaq/'));
const SectionCallToAction = dynamic(() => import('sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionCallToAction'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionForm/'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionRelatedPosts/'));

interface DangerousGoodsDeclarationProps {
  articles: TopArticlesCardType[];
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function DangerousGoodsDeclaration({ articles, pageTitle, formUrl, leadSubtype }: DangerousGoodsDeclarationProps) {
  return (
    <div className={cn('dangerous-goods-declaration')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Freight Templates', href: '/resources/freight-templates' as Route },
            { title: 'Dangerous Goods Declaration', href: '' as Route },
          ]}
        />
      </div>
      <SectionHeader />
      <SectionAbout />
      <SectionPurpose />
      <SectionDocuments />
      <SectionFaq />
      <SectionCallToAction />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
      <SectionRelatedPosts articles={articles} />
    </div>
  );
}

export const getStaticProps = async () => {
  const meta = {
    title: 'Dangerous Goods Declaration Template Free Download | DF Alliance',
    description: 'Download a free dangerous goods declaration template from DF Alliance to ensure safe transport of hazardous cargo.',
    path: '/resources/freight-templates/dangerous-goods-declaration',
  };

  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.DangerousGoodsDeclaration.pageTitle,
  //   formUrl: LeadFormParameters.DangerousGoodsDeclaration.formUrl,
  //   leadSubtype: LeadFormParameters.DangerousGoodsDeclaration.leadSubtype,
  // };

  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return {
      props: {
        articles,
        ...meta,
        // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
        // ...FormParameters,
      }
    };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return {
    props: {
      articles: [],
      ...meta,
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

DangerousGoodsDeclaration.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
